export { EidSearch as EidSearchPage } from './EidSearch';
